<template>
    <div class="pendo-tools-icon">
        <svg
            class="filled-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.3172 3.27624C11.495 3.09937 11.7362 3 11.9877 3H20.0517C20.5754 3 21 3.42225 21 3.94313V11.9637C21 12.2119 20.9017 12.45 20.7263 12.6266L12.6887 20.7178C12.093 21.3175 11.0659 20.8979 11.0659 20.055V12.8804H3.95015C3.10533 12.8804 2.68228 11.8645 3.27964 11.2704L11.3172 3.27624Z"
                fill="var(--text-body-default-base)" />
        </svg>
        <svg
            class="empty-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.3172 3.27624C11.495 3.09937 11.7362 3 11.9877 3H20.0517C20.5754 3 21 3.42225 21 3.94313V11.9637C21 12.2119 20.9017 12.45 20.7263 12.6266L12.6887 20.7178C12.093 21.3175 11.0659 20.8979 11.0659 20.055V12.8804H3.95015C3.10533 12.8804 2.68228 11.8645 3.27964 11.2704L11.3172 3.27624ZM12.3431 4.79643L6.02141 11.0839H11.9239C12.4476 11.0839 12.8721 11.5062 12.8721 12.0271V17.9772L19.1938 11.6133V4.79643H12.3431Z"
                fill="var(--palette-gray-90)" />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'PendoToolsIcon',
};
</script>
